<div class="container-fluid">
  <div class="main-body">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title mb-3 mt-1">
          <div class="d-flex align-items-center">
            <mat-icon color="primary" class="me-1">manage_accounts</mat-icon>
            <p class="ms-2 mb-0">{{ "PROFILE.TITLE" | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row compact-inputs dropdown-pd-none">
      <!-- Profile Card (Left Column) -->
      <div class="col-12 col-lg-4">
        <mat-card class="h-100" appearance="outlined">
          <mat-card-content class="p-3 p-md-4">
            <div class="d-flex flex-column align-items-center text-center">
              <div class="position-relative mb-3">
                <img
                  [src]="
                    imagePreview == null
                      ? getDocThumbnailImage(form.data['imageId'])
                      : imagePreview
                  "
                  alt="Image Preview"
                  class="profile-image rounded-circle"
                  width="110"
                />
                <button
                  mat-mini-fab
                  color="primary"
                  class="position-absolute bottom-0 end-0"
                  [matTooltip]="'PROFILE.UPDATE_PROFILE' | translate"
                  matTooltipPosition="right"
                  data-bs-toggle="modal"
                  data-bs-target="#imageModal"
                  (click)="resetFileInput(file)"
                >
                  <mat-icon>camera_alt</mat-icon>
                </button>
              </div>

              <!-- User Info -->
              <div class="text-center w-100">
                <h5 class="fw-bold text-truncate my-2">
                  {{ form.data["firstName"] }} {{ form.data["lastName"] }}
                </h5>
                <p
                  class="text-muted mb-2 d-flex align-items-center justify-content-center"
                >
                  <mat-icon color="primary" class="me-1 icon-compact"
                    >mail</mat-icon
                  >
                  <span>{{ form.data["loginId"] }}</span>
                </p>
                <mat-chip class="mb-3" color="primary" variant="outlined">
                  {{ "PROFILE.ROLE" | translate }}:
                  <b class="ms-1">{{ form.data["roleName"] }}</b>
                </mat-chip>
              </div>

              <!-- Quick Actions -->
              <div class="mt-2 profile-width-btn">
                <button
                  mat-stroked-button
                  color="primary"
                  data-bs-toggle="modal"
                  data-bs-target="#imageModal"
                  (click)="resetFileInput(file)"
                  [matTooltip]="'PROFILE.UPDATE_PROFILE' | translate"
                  class="w-100"
                >
                  <i class="fa fa-edit"></i>
                  <span class="ms-2">{{
                    "PROFILE.UPDATE_PROFILE" | translate
                  }}</span>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Edit Form (Right Column) -->
      <div class="col-12 col-lg-8">
        <mat-card appearance="outlined">
          <mat-card-header class="pb-0 pt-3 pt-md-4">
            <mat-card-title class="fw-bold mb-0 d-flex align-items-center">
              <mat-icon color="primary" class="me-2">edit</mat-icon>
              <h5 class="mb-0">{{ "PROFILE.TITLE" | translate }}</h5>
            </mat-card-title>
          </mat-card-header>

          <mat-card-content class="p-3 p-md-4">
            <form class="needs-validation" novalidate #uiForm="ngForm">
              <div class="mb-4">
                <p *ngIf="form['error'] == false && form['message']">
                  <app-ncs-alert [message]="form['message']" type="success" />
                </p>
                <p *ngIf="form['error'] == true && form['message']">
                  <app-ncs-alert [message]="form['message']" type="danger" />
                </p>
              </div>

              <!-- Form Fields -->
              <div class="row g-3">
                <!-- First Name -->
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{
                      "PROFILE.FIRST_NAME" | translate
                    }}</mat-label>
                    <input
                      matInput
                      required
                      [(ngModel)]="form.data['firstName']"
                      name="firstName"
                      #firstName="ngModel"
                      type="text"
                      maxlength="30"
                      [placeholder]="
                        'PROFILE.PLACEHOLDERS.FIRST_NAME' | translate
                      "
                    />
                    <mat-error *ngIf="firstName.errors?.['required']">
                      {{ "PROFILE.REQUIRED_FIRST_NAME" | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Last Name -->
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{ "PROFILE.LAST_NAME" | translate }}</mat-label>
                    <input
                      matInput
                      required
                      [(ngModel)]="form.data['lastName']"
                      name="lastName"
                      #lastName="ngModel"
                      type="text"
                      maxlength="30"
                      [placeholder]="
                        'PROFILE.PLACEHOLDERS.LAST_NAME' | translate
                      "
                    />
                    <mat-error *ngIf="lastName.errors?.['required']">
                      {{ "PROFILE.REQUIRED_LAST_NAME" | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Login ID (Readonly) -->
                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{ "PROFILE.LOGIN_ID" | translate }}</mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['loginId']"
                      type="email"
                      name="loginId"
                      [placeholder]="
                        'PROFILE.PLACEHOLDERS.LOGIN_ID' | translate
                      "
                    />
                  </mat-form-field>
                </div>

                <!-- Login Code (Readonly) — user-side only -->
                <div class="col-12" *ngIf="form.data['loginCode']">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{
                      "PROFILE.LOGIN_CODE" | translate
                    }}</mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['loginCode']"
                      type="text"
                      name="loginCode"
                      [placeholder]="
                        'PROFILE.PLACEHOLDERS.LOGIN_CODE' | translate
                      "
                    />
                  </mat-form-field>
                </div>

                <!-- Mobile ID (Readonly) — user-side only -->
                <div class="col-12" *ngIf="form.data['mobileId']">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{ "PROFILE.MOBILE_NO" | translate }}</mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['mobileId']"
                      type="text"
                      name="mobileId"
                      [placeholder]="
                        'PROFILE.PLACEHOLDERS.MOBILE_NO' | translate
                      "
                    />
                  </mat-form-field>
                </div>

                <!-- Role (Readonly) -->
                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{ "PROFILE.ROLE" | translate }}</mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['roleName']"
                      type="text"
                      name="roleName"
                      [placeholder]="'PROFILE.PLACEHOLDERS.ROLE' | translate"
                    />
                  </mat-form-field>
                </div>
                <div class="col-12 text-lg-start text-center">
                  <div *ngIf="form.data['id'] > 0">
                    <img
                      [src]="
                        imagePreview == null
                          ? getDoc(form.data['imageId'])
                          : imagePreview
                      "
                      alt="Image Preview"
                      class="img-thumbnail"
                      style="max-width: 200px"
                    />
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div
                class="d-flex flex-column gap-3 flex-md-row justify-content-center justify-content-lg-between align-items-center flex-wrap mt-4 pt-4 border-top"
              >
                <div class="mb-3 mb-md-0">
                  <button
                    mat-stroked-button
                    color="warn"
                    class="d-flex align-items-center justify-content-center"
                    (click)="resetProfileImage()"
                    [matTooltip]="'Remains.RESET_PROFILE' | translate"
                    matTooltipPosition="above"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "Remains.RESET_PROFILE" | translate
                    }}</span>
                  </button>
                </div>

                <div
                  class="d-flex gap-3 flex-wrap justify-content-between justify-content-lg-start"
                >
                  <!-- Change Password Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    class="d-flex align-items-center justify-content-center"
                    data-bs-toggle="modal"
                    data-bs-target="#changepass"
                    (click)="resetCpForm()"
                    [matTooltip]="'PROFILE.CHANGE_PASSWORD' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="me-2">key</mat-icon>
                    <span>{{ "PROFILE.CHANGE_PASSWORD" | translate }}</span>
                  </button>

                  <!-- Save Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    class="d-flex align-items-center justify-content-center"
                    [matTooltip]="'PROFILE.SAVE' | translate"
                    matTooltipPosition="above"
                    [disabled]="uiForm['invalid']"
                    (click)="save()"
                  >
                    <mat-icon class="me-2">save</mat-icon>
                    {{ "PROFILE.SAVE" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<!-- Change Password Modal -->
<div
  class="modal fade"
  id="changepass"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="changepassLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="changepassLabel">
          {{ "PROFILE.CHANGE_PASSWORD_MODAL.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'PROFILE.CHANGE_PASSWORD_MODAL.CLOSE' | translate"
          [title]="'PROFILE.CHANGE_PASSWORD_MODAL.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div>
          <p *ngIf="cpForm['error'] == false && cpForm['message']">
            <app-ncs-alert
              [message]="cpForm['message']"
              type="success"
            ></app-ncs-alert>
          </p>
          <p *ngIf="cpForm['error'] == true && cpForm['message']">
            <app-ncs-alert
              [message]="cpForm['message']"
              type="danger"
            ></app-ncs-alert>
          </p>
        </div>

        <form class="row compact-inputs dropdown-pd-none" #cpform="ngForm">
          <!-- Old Password -->
          <div class="col-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.OLD_PASSWORD" | translate
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['oldPassword']"
                name="oldPassword"
                #oldPassword="ngModel"
                [type]="showOldPassword ? 'text' : 'password'"
                id="oldPassword"
                [placeholder]="'PROFILE.PLACEHOLDERS.OLD_PASSWORD' | translate"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="showOldPassword = !showOldPassword"
                [attr.aria-label]="
                  showOldPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">
                  {{ showOldPassword ? "visibility" : "visibility_off" }}
                </mat-icon>
              </button>
            </mat-form-field>
            <div *ngIf="oldPassword.errors?.['required']" class="text-danger">
              <small>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.REQUIRED_OLD_PASSWORD"
                  | translate
              }}</small>
            </div>
          </div>

          <!-- New Password -->
          <div class="col-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.NEW_PASSWORD" | translate
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['newPassword']"
                name="newPassword"
                #newPassword="ngModel"
                [type]="showNewPassword ? 'text' : 'password'"
                id="newPassword"
                [placeholder]="'PROFILE.PLACEHOLDERS.NEW_PASSWORD' | translate"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="showNewPassword = !showNewPassword"
                [attr.aria-label]="
                  showNewPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">
                  {{ showNewPassword ? "visibility" : "visibility_off" }}
                </mat-icon>
              </button>
            </mat-form-field>
            <div *ngIf="newPassword.errors?.['required']" class="text-danger">
              <small>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.REQUIRED_NEW_PASSWORD"
                  | translate
              }}</small>
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="col-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD" | translate
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['confirmPassword']"
                name="confirmPassword"
                #confirmPassword="ngModel"
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                [placeholder]="
                  'PROFILE.PLACEHOLDERS.CONFIRM_PASSWORD' | translate
                "
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="showConfirmPassword = !showConfirmPassword"
                [attr.aria-label]="
                  showConfirmPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">
                  {{ showConfirmPassword ? "visibility" : "visibility_off" }}
                </mat-icon>
              </button>
            </mat-form-field>
            <div
              *ngIf="confirmPassword.errors?.['required']"
              class="text-danger"
            >
              <small>{{
                "PROFILE.CHANGE_PASSWORD_MODAL.REQUIRED_CONFIRM_PASSWORD"
                  | translate
              }}</small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="cpform['invalid']"
          [title]="'PROFILE.CHANGE_PASSWORD_MODAL.UPDATE_PASSWORD' | translate"
          (click)="changePassword()"
          class="px-4"
        >
          <mat-icon>save</mat-icon>
          {{ "PROFILE.CHANGE_PASSWORD_MODAL.UPDATE_PASSWORD" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'PROFILE.CHANGE_PASSWORD_MODAL.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "PROFILE.CHANGE_PASSWORD_MODAL.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Image Update Modal -->
<div
  class="modal fade"
  id="imageModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="imageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="imageModalLabel">
          {{ "PROFILE.IMAGE_MODAL.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'PROFILE.IMAGE_MODAL.CLOSE' | translate"
          (click)="cancelCropping()"
        ></button>
      </div>
      <div class="modal-body compact-inputs dropdown-pd-none">
        <mat-form-field
          appearance="outline"
          class="w-100 mt-3"
          floatLabel="always"
        >
          <mat-label>{{
            "PROFILE.IMAGE_MODAL.SELECT_IMAGE" | translate
          }}</mat-label>
          <!-- Hidden real file input -->
          <input
            #file
            type="file"
            id="imageId"
            name="imageId"
            accept="image/jpeg, image/jpg, image/png, image/gif"
            (click)="onFileChooseClicked()"
            (change)="onFileChanged($event, 'imageId', form.data['imageId'])"
            style="display: none"
          />
          <!-- Visible readonly matInput proxy -->
          <input
            matInput
            readonly
            [value]="
              file.files && file.files.length > 0 ? file.files[0].name : ''
            "
            (click)="file.click()"
            [placeholder]="'PROFILE.IMAGE_MODAL.SELECT_IMAGE' | translate"
            style="cursor: pointer"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="icon-pd-none"
            (click)="file.click()"
            style="cursor: pointer"
          >
            <mat-icon class="text-secondary icon-compact">attach_file</mat-icon>
          </button>
        </mat-form-field>

        <div *ngIf="fileError" class="text-danger">
          {{ "PROFILE.IMAGE_MODAL.INVALID_FILE" | translate }}
        </div>
        <div *ngIf="imageSize" class="text-danger">
          {{ "PROFILE.IMAGE_MODAL.FILE_SIZE_ERROR" | translate }}
        </div>

        <!-- Cropper Action Buttons -->
        <div class="button-row my-3" *ngIf="showCropper">
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomIn()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>zoom_in</mat-icon>
            <small>{{ "PROFILE.IMAGE_MODAL.ZOOM_IN" | translate }}</small>
          </button>
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomOut()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>zoom_out</mat-icon>
            <small>{{ "PROFILE.IMAGE_MODAL.ZOOM_OUT" | translate }}</small>
          </button>
          <button
            mat-stroked-button
            color="primary"
            (click)="rotateRight()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>rotate_right</mat-icon>
            <small>{{ "PROFILE.IMAGE_MODAL.ROTATE_RIGHT" | translate }}</small>
          </button>
          <button
            mat-stroked-button
            color="primary"
            (click)="rotateLeft()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>rotate_left</mat-icon>
            <small>{{ "PROFILE.IMAGE_MODAL.ROTATE_LEFT" | translate }}</small>
          </button>
          <button
            mat-stroked-button
            color="primary"
            (click)="flipHorizontal()"
            [class.enabled]="transform.flipH"
            class="me-1 mb-2"
          >
            <mat-icon>flip</mat-icon>
            <small>{{
              "PROFILE.IMAGE_MODAL.FLIP_HORIZONTAL" | translate
            }}</small>
          </button>
          <button
            mat-stroked-button
            color="primary"
            (click)="flipVertical()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>flip</mat-icon>
            <small>{{ "PROFILE.IMAGE_MODAL.FLIP_VERTICAL" | translate }}</small>
          </button>
        </div>

        <!-- Preview and Cropper Row -->
        <div class="row preview-row">
          <div class="col-12">
            <div class="cropper-wrapper">
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [imageURL]="imageURL"
                [hidden]="hidden"
                [disabled]="disabled"
                [alignImage]="alignImage"
                [roundCropper]="roundCropper"
                [backgroundColor]="backgroundColor"
                imageAltText="Alternative image text"
                [allowMoveImage]="allowMoveImage"
                [hideResizeSquares]="hideResizeSquares"
                [canvasRotation]="canvasRotation"
                [aspectRatio]="aspectRatio"
                [containWithinAspectRatio]="containWithinAspectRatio"
                [maintainAspectRatio]="maintainAspectRatio"
                [cropperStaticWidth]="cropperStaticWidth"
                [cropperStaticHeight]="cropperStaticHeight"
                [cropperMinWidth]="cropperMinWidth"
                [cropperMinHeight]="cropperMinHeight"
                [cropperMaxWidth]="cropperMaxWidth"
                [cropperMaxHeight]="cropperMaxHeight"
                [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
                [(transform)]="transform"
                [onlyScaleDown]="true"
                format="png"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (cropperReady)="cropperReady($event)"
                (loadImageFailed)="loadImageFailed()"
                (transformChange)="transformChange($event)"
                [style.display]="showCropper ? 'block' : 'none'"
                output="base64"
              ></image-cropper>
            </div>
          </div>
          <div class="col-12" *ngIf="showCropper">
            <div class="preview-card">
              <h6 class="fw-bold mt-3">
                {{ "PROFILE.IMAGE_MODAL.PREVIEW" | translate }}
              </h6>
              <div class="text-center">
                <img
                  *ngIf="croppedImage"
                  [src]="croppedImage"
                  alt="Cropped Preview"
                  class="cropped-preview"
                />
                <div *ngIf="!croppedImage" class="no-preview">
                  <mat-icon class="no-preview-icon">image</mat-icon>
                  <p class="text-muted">
                    {{ "PROFILE.IMAGE_MODAL.PREVIEW" | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          class="btn-sm"
          [disabled]="!croppedImage"
          (click)="saveCroppedImage()"
          [attr.data-bs-dismiss]="!imageSize ? 'modal' : null"
          [title]="'PROFILE.IMAGE_MODAL.SAVE_IMAGE' | translate"
        >
          <mat-icon>save</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.SAVE_IMAGE" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          class="btn-sm"
          data-bs-dismiss="modal"
          (click)="cancelCropping()"
          [title]="'PROFILE.IMAGE_MODAL.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
